import React from 'react';

/**
 * Sidebar Component
 */
const Sidebar = (props) => {
    const { 
        soccerImg = '', 
        children = '', 
        ...restProps 
    } = props;
    
    let classList = 'acaSidebar'
    if ( soccerImg ) classList += ' acaSidebar--hasSoccerImg';

    return (
        <div className={classList}>
            {children}
        </div>
    );
}

export default Sidebar;

